<template>
  <div class="go-in">
    <banner img="../assets/img/bgtop.jpg" title="公司简介" />
    <div class="section" v-loading="loading">
		<div class="product-one-box">
			<img class="product-one-img01" src="../assets/img/product-one-img.png" alt="" />
			<div class="p-video">
			 <video src="@/assets/img/video.mp4" loop autoplay controls width="100%"></video>
			</div>
		</div>
		<div class="goin-box-one">
			<div class="goin-box-one-content">
				<div class="goin-box-one-left">
					<h3>关于我们</h3>
					<p>ABOUT US</p>
					<p class="content">
            通慧科技集团（证券代码：872345）成立于2005年6月，是一家专注于工程质量安全管控及智慧工程感知软硬件产品，集研发、设计、施工、生产于一体的综合服务商。公司先后荣获多项重要荣誉，包括国家高新技术企业、国家专精特新“小巨人”企业、江西省专业化“小巨人”企业、江西省“专精特新”中小企业、省大数据示范企业、省产教融合示范企业、省级企业实践培训基地、省“重点数字经济产品”推荐企业以及科技“小巨人”领军企业等称号。2022年，“通慧科技TOHUI SCIENCE&TECHNOLOGY”品牌被江西省工业强省建设工作领导小组办公室、省市场监督管理局、省工信厅认定为“赣出精品”商标。此外，公司还获批设立了市级工程技术中心和省级企业技术中心，并在2025年获批设立“博士科研创新中心”。</p>
					<p class="content">
						公司分别在南昌和宜春、北京设立基地和技术研发中心，办公面积1万余平方米，拥有近百项自主知识产权的发明和实新专利、软件著作权。已成长为国内智慧工程、智慧感知、城市生命线这一细分领域有较大影响力的企业。直接中标参与了26个省市自治区智慧交通、智慧建造、路网感知项目200余个，软件用户达3000余家。与南京大学、华中科技大学、中国地质大学（武汉）、山东大学、重庆大学、南昌大学、华东交通大学、东华理工大学、江西交通职业技术学院、南昌航空大学等985、211高校签订产学研合作协议和技术研究中心。
					</p>
					<p class="content">
						公司现有员工近200人，其中取得研究员、教授级高级工程师、 高级工程师及以上占15%、工程师占30%。持有交通部注册监理工程师、造价工程师、检测工程师、结构工程师、注册建造师、软件工程师、信息监理工程师、安全管理工程师、环保工程师等专业技术人员50余人，多名专业技术人员被聘为科技部、交通部、省政府专家和评委，参与了《中华人民共和国交通运输部交通监理行业标准JTG-2016》、《江西省公路机电补充定额》等相关行业标准制定。
					</p>
				</div>
				<div class="goin-box-one-right">
					<img src="../assets/img/jianjietopmin.png" alt="" />
				</div>
			</div>
		</div>
		
		<div class="goin-box-two">
			<!-- 发展历程 -->
			<div class="content-course">
			    <h3>发展历程</h3>
			    <p>DEVELOPMENT</p>
			  <div class="course-time">
			    <swiper :options="swiperOption" ref="mySwiper">
			      <swiper-slide v-for="(item,index) in courseList" :key="index">
			        <div class="time-show">
			          <div class="time-show-item" v-for="(courseOne,one) in item" :key="one">
			            <div class="item-top" :class="{'order-top' : one%2===1}"></div>
			            <el-divider>
			              <i></i>
			            </el-divider>
			            <div class="item-bottom" :class="{'order' : one%2===1}">
			              <div class="item-bottom-content">
			                <p v-html="courseOne.Content"></p>
			                <p class="year">{{courseOne.Year}}年</p>
			              </div>
			            </div>
			          </div>
			        </div>
			      </swiper-slide>
			      <div class="swiper-button-prev" slot="button-prev"></div>
			      <div class="swiper-button-next" slot="button-next"></div>
			    </swiper>
			  </div>
			</div>
		</div>
		
		<div class="goin-box-three" >
			<!-- 公司荣誉 -->
			<div class="content-honor">
			  <div class="top">
			    <h3>公司荣誉</h3>
			    <p>HONOR</p>
			    <div class="border"></div>
			  </div>
			  <swiper style="width: 1200px;margin: auto;padding: 20px;" :options="swiperOption01" ref="mySwiper01">
			    <swiper-slide v-for="(honor,index) in honorList" :key="index" :style="honor.style">
					<img style="height: 100%;width: 100%;" v-lazy="honor.Img" />
			    </swiper-slide>
			  </swiper>
			  <p class="view">左右拖拽查看</p>
			</div>
		</div>
		
		<div class="goin-box-four" >
			<div class="goin-box-three-content">
				<div class="top">
				  <h3>企业文化</h3>
				  <p>CULTURE</p>
				  <div class="border"></div>
				</div>
				<div class="matter">
					<img src="../assets/img/goin-bg03.jpg" alt=""/>
					<h5>企业使命</h5>
					<p>筑平安工程</p>
					<p>联智慧交通</p>
				</div>
				<div class="matter">
					<img src="../assets/img/goin-bg02.jpg" alt=""/>
					<h5>企业愿景</h5>
					<p>成为工程质量安全管控领航者</p>
				</div>
				<div class="matter">
					<img src="../assets/img/goin-bg04.jpg" alt=""/>
					<h5>企业精神</h5>
					<p>同心高效  追求极致</p>
					<p>通达天下  慧济无疆</p>
				</div>
				<div class="matter">
					<img src="../assets/img/goin-bg05.jpg" alt=""/>
					<h5>企业核心价值观</h5>
					<p>服务赢得口碑</p>
					<p>诚信树立品牌</p>
					<p>技术奠定未来</p>
				</div>
			</div>
		</div>
		
		<div class="goin-box-five" >
			<!-- 公司掠影 -->
			<div class="content-team">
			  <div class="top" style="margin-bottom: 10px;">
			    <h3>公司掠影</h3>
			    <p>COMPANY PHOTOGRAPHY</p>
				<div class="border"></div>
			  </div>
			  <el-carousel :interval="4000" type="card" height="350px">
			    <el-carousel-item v-for="(team,index) in teamItem" :key="index">
			      <div @click="handleImgClick(index)" class="swiper-img" v-lazy:background-image="team"></div>
			    </el-carousel-item>
			  </el-carousel>
			  <p class="view">点击图片查看大图</p>
			</div>
			<el-image-viewer v-if="isShowViewer" :on-close="closeViewer" :url-list="viewerImgList" />
		</div>
		
		<!-- <div class="goin-box-six">
			<div class="content-partner">
			  <div class="top">
			    <h3>合作伙伴</h3>
			    <p>PARTNERS</p>
				<div class="border"></div>
			  </div>
			  <ul class="partner-img">
			    <li v-for="(partner,i) in partnerImg" :key="i">
			      <img v-lazy="partner.Img" alt />
			    </li>
			  </ul>
			</div>
		</div> -->
    </div>
  </div>
</template>

<script>
import Banner from "../components/Banner";
import ElImageViewer from 'element-ui/packages/image/src/image-viewer';
export default {
  components: {
    Banner,
	ElImageViewer
  },
  data() {
    return {
      loading: false,
	  isShowViewer: false,
	  videoSrc: "http://220.176.196.195:5055/group2/M00/00/05/CqgADGIvBJmEJNY-AAAAAFpst7w302.mp4",
	  playerOptions: {
	    playbackRates: [0.5, 1.0, 1.5, 2.0, 4.0, 8.0], //可选择的播放速度
	    autoplay: true, //如果true,浏览器准备好时开始回放。
	    muted: false, // 默认情况下将会消除任何音频。
	    loop: true, // 视频一结束就重新开始。
	    preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
	    language: "zh-CN",
	    aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
	    fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
	    sources: [
	      {
	        type: "",
	        src: "http://220.176.196.195:5055/group2/M00/00/05/CqgADGIvBJmEJNY-AAAAAFpst7w302.mp4" //url地址
	      }
	    ],
	    //poster: "../assets/img/home_top.jpg", //你的封面地址
	    // width: document.documentElement.clientWidth,
	    notSupportedMessage: "此视频暂无法播放，请稍后再试", //允许覆盖Video.js无法播放媒体源时显示的默认信息。
	    controlBar: {
	      timeDivider: true, //当前时间和持续时间的分隔符
	      durationDisplay: true, //显示持续时间
	      remainingTimeDisplay: false, //是否显示剩余时间功能
	      fullscreenToggle: true //全屏按钮
	    }
	  },
	  honorList:[{
		  style:{
			  width:'411px',
			  height:'300px',
		  },
		  Img:'https://file.jxth.com.cn/group1/M00/00/25/wKgKZ2OrtMWAQpJJAACHZy-pT5w284.jpg'
	  },{
		  style:{
			  width:'428px',
			  height:'300px',
		  },
		  Img:'https://file.jxth.com.cn/group1/M00/00/25/wKgKZ2OrsbWAX6RVAACiX7tR4Do472.jpg'
	  },{
		  style:{
			  width:'434px',
			  height:'300px',
		  },
		  Img:'https://file.jxth.com.cn/group1/M00/00/25/wKgKZ2Ors4eAN4rDAACRMEm8RqM978.jpg'
	  },{
		  style:{
			  width:'424px',
			  height:'300px',
		  },
		  Img:'https://file.jxth.com.cn/group1/M00/00/25/wKgKZ2OrsVWALjouAAB06cuTuZk498.jpg'
	  },{
		  style:{
			  width:'424px',
			  height:'300px',
		  },
		  Img:'https://file.jxth.com.cn/group1/M00/00/25/wKgKZ2OrsIyATUpkAAB75YBlhRU070.jpg'
	  },{
		  style:{
			  width:'444px',
			  height:'300px',
		  },
		  Img:'https://file.jxth.com.cn/group1/M00/00/25/wKgKZ2OrrKKAAKv5AACXSB1l79E031.jpg'
	  },{
		  style:{
			  width:'446px',
			  height:'300px',
		  },
		  Img:'https://file.jxth.com.cn/group1/M00/00/25/wKgKZ2OrqGyASCRTAAB2CPjOFcc198.jpg'
	  },{
		  style:{
			  width:'428px',
			  height:'300px',
		  },
		  Img:'https://file.jxth.com.cn/group1/M00/00/25/wKgKZ2OrpsaABgJrAAExOaKzMaQ336.jpg'
	  },{
		  style:{
			  width:'482px',
			  height:'300px',
		  },
		  Img:'https://file.jxth.com.cn/group1/M00/00/25/wKgKZ2Orp7yANzfYAAB4hDKNiAE584.jpg'
	  },{
		  style:{
			  width:'475px',
			  height:'300px',
		  },
		  Img:'https://file.jxth.com.cn/group1/M01/00/24/dSm0ymC91n2ASuV2AAUUSd_q0sc092.png'
	  },{
		  style:{
			  width:'452px',
			  height:'300px',
		  },
		  Img:'https://file.jxth.com.cn/group1/M00/00/25/wKgKZ2OrrSyACepDAACyA8BkbaI750.jpg'
	  },{
		  style:{
		   width:'475px',
		   height:'300px',
		  },
		  Img:'https://file.jxth.com.cn/group1/M01/00/1B/dSm0ymCcx6yATbLDAARwNxXWRTk503.png' 
	  },{
		  style:{
		   width:'403px',
		   height:'300px',
		  },
		  Img:'https://file.jxth.com.cn/group1/M02/00/1B/dSm0ymCc0tGAALEGAAeAb57eE5A375.png' 
	  },{
		  style:{
		   width:'221px',
		   height:'300px',
		  },
		  Img:'https://file.jxth.com.cn/group1/M01/00/1B/dSm0ymCc1FqAcrVgAAPVuRwrEgs146.png' 
	  },{
		  style:{
		   width:'212px',
		   height:'300px',
		  },
		  Img:'https://file.jxth.com.cn/group1/M00/00/25/wKgKZ2OrqR2AVQyzAABDTrRK2g4189.jpg' 
	  },{
		  style:{
		   width:'212px',
		   height:'300px',
		  },
		  Img:'https://file.jxth.com.cn/group1/M00/00/25/wKgKZ2OrqamAB28gAABBne-IZiA141.jpg' 
	  },{
		  style:{
		   width:'212px',
		   height:'300px',
		  },
		  Img:'https://file.jxth.com.cn/group1/M00/00/25/wKgKZ2OrrACAOhyLAABBCARwtPs378.jpg' 
	  },{
		  style:{
		   width:'212px',
		   height:'300px',
		  },
		  Img:'https://file.jxth.com.cn/group1/M00/00/25/wKgKZ2OrrbqAGYQuAABCkY5y_VU877.jpg' 
	  },{
		  style:{
		   width:'216px',
		   height:'300px',
		  },
		  Img:'https://file.jxth.com.cn/group1/M00/00/2D/wKgKZ2O7xJiATgbiAApY1c0zrYw263.png' 
	  },{
		  style:{
		   width:'216px',
		   height:'300px',
		  },
		  Img:'https://file.jxth.com.cn/group1/M00/00/2D/wKgKZ2O7xLeAeDkrAApWCv1mOUE151.png' 
	  },{
		  style:{
		   width:'212px',
		   height:'300px',
		  },
		  Img:'https://file.jxth.com.cn/group1/M00/00/2D/wKgKZ2O7xrSAKgE_AAC2KTLnCqk337.png' 
	  }],
      partnerImg: [{
		  Img:''
	  }],
      courseList: [
		  [{Content: "1、公司成立<br/>2、发布首款软件产品《工程质量安全管理系统V1.0》",Year: "2005"},
		  {Content: "1、获国家信息产业部“双软”企业认证<br/>2、成为中国交通信息产业会员单位<br/>3、公司软件服务用户超过100家",Year: "2006"}],
		  [{Content: "1、《工程质量安全管控平台》获江西省交通厅科技立项<br/>2、与江西省交通厅规划办公室、江西省交通工程造价管理站发起成立规划造价信息理事会并任副理事长兼秘书长单位",Year: "2007"},
		  {Content: "1、被指定为《江西省公路养护定额》配套软件唯一开发单位<br/>2、《工程质量安全管控平台》获南昌市科技局、省科技厅立项及江西省软件用户满意企业",Year: "2008"}],
		  [{Content: "1、《工程质量安全管控平台》获科技部科技型中小企业创新基金立项<br/>2、公司产品“基于3G远程无线加密监控传输系统”国内首次应用于九景技改项目，并获发明专利",Year: "2009"},
		  {Content: "1、《轨道交通安全管控系统》获江西省科技厅立项<br/>2、公司列入南昌市委、市政府人才引智计划，并获专项经费<br/>3、获江西省科技厅科技型技术中小企业证书",Year: "2010"}],
		  [{Content: "1、被授予中国交通信息产业理事单位<br/>2、连续三年被国家税务局评为A级企业<br/>3、公司获得南昌市工商行政管理局AAA信用企业",Year: "2011"},
		  {Content: "1、省内首家获得交通运输部公路机电工程专项监理资质证书的民营企业<br/>2、《公路工程第三方检测管理系统》获江西省交通厅科技立项<br/>3、公司研发产品获得软件著作权、发明和实用专利超过50项",Year: "2012"}],
		  [{Content: "1、成为中国交通建设监理协会机电委员会理事单位<br/>2、成为江西省公共安全产业联盟理事单位<br/>3、中标国家超级工程世界最长沙漠高速北京至新疆临白段",Year: "2013"},
		  {Content: "1、与江西省内主要交通监理甲级单位发起成立江西公路学会监理专业委员会并任委员单位<br/>2、参与《江西省公路机电养护定额》标准编制<br/>3、公司通过ISO9001质量管理体系认定",Year: "2014"}],
		  [{Content: "1、与中国地质大学（武汉）联合成立南昌市分布式光纤传感技术工程技术研究中心<br/>2、国内首次将基于PPP-BOTDA分布式光纤传感技术应用于老谷高速汉江特大桥及全线监测，并获发明及实用新型专利35项<br/>3、获得交通运输部公路工程监理企业信用评价AA级",Year: "2015"},
		  {Content: "1、获得国家高新技术企业认定证书<br/>2、发起成立江西省中小科技企业协会并任副会长单位<br/>3、被授予中国城乡建设产业联盟理事单位<br/>4、与山东大学联合成立南昌市新型环保无机工程材料工程技术研究中心",Year: "2016"}],
		  [{Content: "1、与交通部科学研究院等单位发起成立中国技术市场协会交通专业委员会<br/>2、《分布式光纤传感技术研究》获湖北省交通运输厅科研立项公司产品<br/>3、《可视化智慧管理和监测系统》成功应用于世界最高主塔332米贵州平塘特大桥<br/>4、公司成功登陆新三板，证券简称：通慧科技，股票代码：872345<br/>5、获得交通运输部公路工程监理企业信用评价AA级",Year: "2017"},
		  {Content: "1、获得中国技术市场协会“2018中国交通结构物健康监测领域科技创新突出贡献奖”<br/>2、被江西省工业和信息化委员会认定为“专精特精”企业<br/>3、公司列入南昌市委、市政府、市科协“洪燕领航”计划；列入江西省、南昌市、新建区“映山红计划”<br/>4、与山东大学联合成立南昌市新型环保无机工程材料工程技术研究中心",Year: "2018"}],
		  [{Content: "1、通慧科技被南昌经开区引进为重点培育上市企业<br/>2、成立江西省工程结构安全研究院<br/>3、公司启动A轮上市融资计划，并获得江西省财政投资集团、江西省发展升级引导基金、南昌金开集团等机构的股权投资<br/>4、与中国地质大学、山东大学共同创立山区道路地质灾害预防处治研究中心",Year: "2019"},
		  {Content: "1、集团公司成立<br/>2、与鹰潭国有控股集团、宜春市宜阳新区签订战略合作协议<br/>3、成立子公司：江西正宜结构信息技术有限公司、江西正严检测有限责任公司<br/>4、通慧科技集团完成A轮融资",Year: "2020"}],
		  [{Content: "1、公司入驻新办公大楼<br/>2、通慧科技首次完成非公开发行股票<br/>3、获评经开区2020年度科技“小巨人”领军企业<br/>4、再次通过双软认证<br/>5、获得交通运输部公路工程监理企业信用评价AA级<br/>6、获中国网络安全审查技术与认证中心两项CCRC信息安全服务资质认证证书——信息系统安全运维二级、信息安全风险评估三级",Year: "2021"},
		  {Content: "1、取得涉密信息系统集成总体集成乙级资质<br/>2、获批设立“南昌市光纤传感应用工程技术研究中心”<br/>3、获批设立“南昌市市级企业技术中心”<br/>4、被定为2022年江西省专业化“小巨人”企业<br/>5、软件产品“光纤物联网结构健康监测系统”入选第二届“赣出精品”名单<br/>6、通慧科技与全资子公司江西通慧信息技术有限公司通过国家高新技术企业认定",Year: "2022"}],
	  ],
      teamItem: [
		'https://file.jxth.com.cn/group1/M02/00/1A/dSm0ymCY9gaAdFTlAAGCjTeJlM4650.jpg',
		'https://file.jxth.com.cn/group1/M01/00/1A/dSm0ymCY9gaAbqKuAAF2spn6Ghc367.jpg',
		'https://file.jxth.com.cn/group1/M03/00/1A/dSm0ymCY9gaAAZjGAAFggWxlgQI304.jpg',
		'https://file.jxth.com.cn/group1/M02/00/1A/dSm0ymCY9geAf4yGAAGeeQ0-6RA917.jpg',
		'https://file.jxth.com.cn/group1/M01/00/1A/dSm0ymCY9geANv9yAAGiSzqQKbM284.jpg',
		'https://file.jxth.com.cn/group1/M00/00/1A/dSm0ymCY9gaAbq0BAAFyedf3Qkk859.jpg',
		'https://file.jxth.com.cn/group1/M01/00/1A/dSm0ymCY9geAcd2DAAGP3-hEI_g146.jpg',
		'https://file.jxth.com.cn/group1/M03/00/1A/dSm0ymCY9giAOkwrAAGa8RnXyVQ946.jpg',
		'https://file.jxth.com.cn/group1/M03/00/1A/dSm0ymCY9geAbVlMAAFTxsNtaOs074.jpg',
		'https://file.jxth.com.cn/group1/M00/00/1A/dSm0ymCY9giAX4erAAFAEVswQpM515.jpg',
		'https://file.jxth.com.cn/group1/M00/00/1A/dSm0ymCY9geAJVoRAAHEps49Wuc202.jpg',
		'https://file.jxth.com.cn/group1/M02/00/1A/dSm0ymCY9giAJ5zfAAHEk48NPbk347.jpg',
		'https://file.jxth.com.cn/group1/M01/00/1A/dSm0ymCY9giAYxvOAADm_HM3b9Q242.jpg'
	  ],
	  viewerImgList:[],
      swiperOption: {
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        }
      },
	  swiperOption01:{
		  effect: 'coverflow',
		  grabCursor: true,
		  centeredSlides: true,
		  slidesPerView: 'auto',
		  autoplay: true,
		  coverflow: {
		    rotate: 50,
		    stretch: 0,
		    depth: 100,
		    modifier: 1,
		    slideShadows: true
		  }
	  },
    };
  },
  mounted() {
	  
  },
  methods:{
	  // 点击缩略图的方法    
	  handleImgClick(index) {
	  	this.isShowViewer = true
	  	let tempImgList = [...this.teamItem]
	  	let temp = []
	  	for (let i = 0; i < index; i++) {
	  		temp.push(tempImgList.shift())
	  	}
	  	this.viewerImgList = tempImgList.concat(temp)
	  },
	  // 关闭查看器
	  closeViewer() {
	    this.isShowViewer = false
	  },
  }
};
</script>

<style lang="scss" scoped>
* {
  margin: 0;
  padding: 0;
}

.go-in {
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
  .section {
    width: 100%;
	
	.product-one-box{
		width: 100%;
		position: relative;
		
		.product-one-img01{
			position: absolute;
			left: 50%;
			margin-left: -689px;
			top: 45px;
		}
		.product-content {
		  width: 1200px;
		  margin: 0 auto;
		  background-color: #fff;
		}
		.p-video {
		  width: 1000px;
		  margin: 0 auto;
		  padding: 180px 0px 50px 0px;
		}
	}
	
	.goin-box-one{
		background-color: #fafafa;
		
		.goin-box-one-content{
			width: 1200px;
			margin: 0 auto;
			display: flex;
			justify-content: space-around;
			padding: 40px 0;
			
			.goin-box-one-left{
				width: 600px;
				h3{
					color: #3c6088;
					font-size: 26px;
					font-weight: normal;
				}
				p{
					margin-top: 10px;
					margin-bottom: 20px;
				}
				.content{
					margin-top: 5px;
					margin-bottom: 5px;
					text-indent: 30px;
					font-size: 15px;
					line-height: 1.8;
				}
			}
			.goin-box-one-right{
				width: 600px;
				img{
					width: 600px;
					margin-left: 50px;
					margin-top: 50px;
				}
			}
			
		}
	}
	
	.goin-box-two{
		background-image: url(../assets/img/goin-bg01.jpg);
		background-attachment: fixed;
		background-size: cover;
		background-position: center;
		background-repeat: no-repeat;
		//发展历程
		.content-course {
			padding: 40px 0;
			h3{
				text-align: center;
				color: #FFFFFF;
				font-size: 30px;
				font-weight: normal;
			}
			p{
				margin-top: 10px;
				margin-bottom: 20px;
				font-size: 20px;
				text-align: center;
				color: #f5f5f5;
			}
		  .course-time {
		    width: 1000px;
		    height: 560px;
		    margin: 20px auto;
		    .swiper-container {
		      height: 100%;
		    }
		    .time-show {
		      width: 700px;
		      height: 100%;
		      margin: 0 auto;
		      display: flex;
		      .time-show-item {
		        width: 350px;
		        height: 100%;
		        overflow: hidden;
		        display: flex;
		        flex-direction: column;
		
		        .item-top,
		        .item-bottom {
		          height: 270px;
		        }
		        .item-bottom {
		          .item-bottom-content {
					background-color: rgba($color: #000000, $alpha: 0.5);
					height: 250px;
					position: relative;
					margin: 10px 0px;
		            p {
						color: #fff;
						font-size: 15px;
						text-align: left;
						padding: 15px;
						margin: 0px;
		            }
					.year{
						position: absolute;
						text-align: center;
						font-size: 20px;
						bottom: 0px;
						left: 50%;
						margin-left: -47.5px;
					}
		          }
		        }
		      }
		    }
		  }
		}
		
	}
	
	.goin-box-three{
		//公司荣誉
		.content-honor {
			padding: 40px 0;
			.swiper-pagination01{
				text-align: center;
			}
			.view{
				text-align: center;
				font-size: 14px;
				color: #999;
			}
		}
	}
	
	.goin-box-four{
		background-color: #fafafa;
		.goin-box-three-content{
			width: 1200px;
			margin: 0 auto;
			padding: 40px 0;
			overflow: hidden;
			
			.matter{
				margin-top: 10px;
				float: left;
				width: 25%;
				text-align: center;
				h5{
					font-size: 20px;
					margin-top: 5px;
				}
				p{
					font-size: 16px;
					margin-top: 5px;
				}
			}
		}
	}
	
	.goin-box-five{
		//公司掠影
		.content-team {
			padding: 40px 200px;
			.swiper-img {
				height: 350px;
				background: no-repeat center;
				background-size: cover;
			}
			.view{
				text-align: center;
				font-size: 14px;
				color: #999;
			}
		}
	}
	
	.goin-box-six{
		background-color: #fafafa;
		//合作伙伴
		.content-partner {
		  padding: 40px 0;
		  .partner-img {
		    width: 950px;
		    margin: 20px auto;
		    display: flex;
		    justify-content: flex-start;
		    flex-wrap: wrap;
		    li {
		      width: 107px;
		      height: 107px;
		      list-style: none;
		      margin: 10px 25px;
		
		      img {
		        width: 100%;
		        height: 100%;
		        border: 1px solid rgb(194, 218, 235);
		      }
		    }
		  }
		}
	}
  }
}

@keyframes imgboxkey {
  0% {
    border: solid rgb(29, 66, 185) 2px;
  }
  40% {
    border: solid rgb(255, 255, 255) 2px;
  }
  60% {
    border: solid rgb(255, 255, 255) 2px;
  }
  100% {
    border: solid rgb(29, 66, 185) 2px;
  }
}

@keyframes imgbo {
  0% {
    transform: scale(1);
    box-shadow: 0px 0px 0px 0px #ababab;
  }
  50% {
    transform: scale(1.1);
    box-shadow: 0px 0px 10px 5px #ababab;
  }
  100% {
    transform: scale(1);
    box-shadow: 0px 0px 0px 0px #ababab;
  }
}
.el-divider--horizontal {
  margin: 1px 0;
}

.top {
  h3,
  p {
    text-align: center;
    color: #3c6088;
    font-weight: 400;
    padding: 10px 0;
  }
  h3 {
    font-size: 30px;
  }
  p {
    font-size: 20px;
  }
  .border {
    border-bottom: 1px solid #3c6088;
    width: 15%;
    margin: 0 auto;
  }
}
// .swiper-button-disabled {
//   display: none;
// }
.order {
  order: -1;
}
.order-top {
	order: 1;
}
.el-divider {
  background-color:#FFFFFF;
  height: 3px;
  .el-divider__text {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    padding: 0px;
    color: #fff;
    border: 3px solid #bd282b;
  }
}
.el-divider-active {
  background-color: #3c6088;
}
.honor-big-img {
  width: 100%;
  height: 100%;
  z-index: 10;
  text-align: center;
  //background-color: #14679f;
  .el-dialog__wrapper {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    overflow: auto;
    margin: 0;

    .el-dialog__body {
      overflow: hidden;
      img {
        width: 100%;
      }
    }
  }
}
</style>